export const WELCOME_SLIDES = [
  {
    id: "ai-powered-investing",
    layoutProfile: "featureBar",
    background: "#F8F9FB",
    titleParts: [
      { text: "AI-Powered", color: "#2B70C5", display: "block" },
      { text: "Investing", color: "#1A2B4B", display: "block" },
    ],
    subtitle: "Smarter insights. Stronger portfolios. Better outcomes.",
    heroImage: "/images/appWelcome/slide-1/hero/ai-powered-investing-1.png",
    features: [
      {
        icon: "/images/appWelcome/slide-1/features/aipowerd-icon-1.png",
        title: "AI-Powered Decisions",
      },
      {
        icon: "/images/appWelcome/slide-1/features/aipowerd-icon-2.png",
        title: "NSE Focused",
        subtitle: "Exclusively on NSE Listed stocks",
      },
      {
        icon: "/images/appWelcome/slide-1/features/aipowerd-icon-3.png",
        title: "Data Driven",
        subtitle: "Backed by 9+ years of research",
      },
      {
        icon: "/images/appWelcome/slide-1/features/aipowerd-icon-4.png",
        title: "Trusted By",
        subtitle: "10,000+ Smart Investors",
      },
    ],
  },
  {
    id: "global-markets",
    layoutProfile: "featureBar",
    background: "#F8F9FB",
    titleParts: [
      { text: "AI Analyses", color: "#1A2B4B", display: "block" },
      { text: "10+ Markets", color: "#07B589", display: "block" },
    ],
    subtitle: "Comprehensive coverage across India, US & Global Markets",
    heroImage: "/images/appWelcome/slide-2/hero/ai-analyses-10-markets.png",
    features: [
      {
        icon: "/images/appWelcome/slide-2/features/market-icon-1.png",
        title: "10+ Global Markets",
      },
      {
        icon: "/images/appWelcome/slide-2/features/market-icon-2.png",
        title: "Comprehensive Coverage",
      },
      {
        icon: "/images/appWelcome/slide-2/features/market-icon-3.png",
        title: "Real-Time Opportunities",
      },
      {
        icon: "/images/appWelcome/slide-2/features/market-icon-4.png",
        title: "Diverse Market Intelligence",
      },
    ],
  },
  {
    id: "data-points",
    layoutProfile: "dataGrid",
    background: "#F8F9FB",
    titleParts: [
      { text: "Powered by ", color: "#1A2B4B", display: "inline" },
      { text: "1Bn+", color: "#2B70C5", display: "inline" },
      { text: " Data Points", color: "#1A2B4B", display: "inline" },
    ],
    subtitle: "Unmatched depth. Real-time intelligence. Better decisions.",
    heroImage: "/images/appWelcome/slide-3/hero/powered-by-1Bn-data-points.png",
    featuresLayout: "grid",
    features: [
      {
        icon: "/images/appWelcome/slide-3/features/data-point-icon-1.png",
        title: "Price Data",
      },
      {
        icon: "/images/appWelcome/slide-3/features/data-point-icon-2.png",
        title: "News & Filings",
      },
      {
        icon: "/images/appWelcome/slide-3/features/data-point-icon-3.png",
        title: "Social Sentiment",
      },
      {
        icon: "/images/appWelcome/slide-3/features/data-point-icon-4.png",
        title: "Macroeconomic Indicators",
      },
      {
        icon: "/images/appWelcome/slide-3/features/data-point-icon-5.png",
        title: "Fundamental Analysis",
      },
      {
        icon: "/images/appWelcome/slide-3/features/data-point-icon-6.png",
        title: "Technical Analysis",
      },
    ],
  },
  {
    id: "reinforcement-learning",
    layoutProfile: "featureBar",
    background: "#F8F9FB",
    titleParts: [
      { text: "Built With", color: "#1A2B4B", display: "block" },
      { text: "Reinforcement Learning", color: "#6D4BD3", display: "block" },
    ],
    subtitle:
      "Continuously Learning. Adapting Strategies. Improves outcomes.",
    heroImage:
      "/images/appWelcome/slide-4/hero/built-reinforcement-learning.png",
    features: [
      {
        icon: "/images/appWelcome/slide-4/features/reinforcement-learning-icon-1.png",
        title: "Continuously",
        subtitle: "Learning",
      },
      {
        icon: "/images/appWelcome/slide-4/features/reinforcement-learning-icon-2.png",
        title: "Smarter",
        subtitle: "Strategies",
      },
      {
        icon: "/images/appWelcome/slide-4/features/reinforcement-learning-icon-3.png",
        title: "Best",
        subtitle: "Outcomes",
      },
      {
        icon: "/images/appWelcome/slide-4/features/reinforcement-learning-icon-4.png",
        title: "Adaptive",
        subtitle: "Intelligence",
      },
    ],
  },
  {
    id: "one-ai",
    layoutProfile: "oneAi",
    background: "#F8F9FB",
    titleParts: [
      { text: "One AI,", color: "#2B70C5", display: "inline" },
      { text: " Every Investing Need", color: "#1A2B4B", display: "inline" },
    ],
    subtitle: "Research • Protect • Invest • Diversify",
    subtitlePlacement: "belowHero",
    showCta: true,
    ctaPlacement: "afterHero",
    heroImage: "/images/appWelcome/slide-5/hero/one-ai-every-investing-need.png",
    featuresLayout: "productGrid",
    features: [
      {
        icon: "/images/appWelcome/slide-5/features/one-ai-icon-1.png",
        title: "PHC",
        description: "Portfolio Health Check",
        badge: "FREE",
        badgeVariant: "cyan",
      },
      {
        icon: "/images/appWelcome/slide-5/features/one-ai-icon-2.png",
        title: "Prime",
        description: "Personalized portfolio advisory",
      },
      {
        icon: "/images/appWelcome/slide-5/features/one-ai-icon-3.png",
        title: "AI Stock Picks",
        description: "High-conviction trade ideas",
      },
      {
        icon: "/images/appWelcome/slide-5/features/one-ai-icon-4.png",
        title: "US Multi-Asset Portfolio",
        description: "Global diversification",
        badge: "NEW",
        badgeVariant: "purple",
      },
      {
        icon: "/images/appWelcome/slide-5/features/one-ai-icon-5.png",
        title: "AI-Powered Portfolio",
        description: "Personalized long-term investing",
      },
      {
        icon: "/images/appWelcome/slide-5/features/one-ai-icon-6.png",
        title: "Atlas",
        description: "Global market opportunities",
        badge: "NEW",
        badgeVariant: "purple",
      },
      {
        icon: "/images/appWelcome/slide-5/features/one-ai-icon-7.png",
        title: "Protect",
        description: "Risk Management",
      },
    ],
  },
];
